import React from 'react';
import PropTypes from 'prop-types';
import { Div } from '@pinpoint/design-kit';

import { noOp } from 'src/functions';
import CONSTANTS from 'src/store/constants';
import StatusFilterButton from 'src/components/status_filter_button';

function StatusFilterButtonGroup({ selectedCode, apiStatus, onFilterButtonClick }) {
  const pendingApprovalSelected = selectedCode === CONSTANTS.TAL_MODEL.FILTER.PENDING_APPROVAL;
  const inProgressSelected = selectedCode === CONSTANTS.TAL_MODEL.FILTER.IN_PROGRESS;
  const errorSelected = selectedCode === CONSTANTS.TAL_MODEL.FILTER.ERRORED;
  const completedSelected = selectedCode === CONSTANTS.TAL_MODEL.FILTER.COMPLETED;
  return (
    <Div data-debug="filter-button-group-cmp">
      <StatusFilterButton
        color="marigold"
        selected={pendingApprovalSelected}
        apiStatus={apiStatus}
        text="Pending Approval"
        data-tip="View Pending Approval status only"
        onClick={() => onFilterButtonClick(CONSTANTS.TAL_MODEL.FILTER.PENDING_APPROVAL)}
      />
      <StatusFilterButton
        color="blueLight"
        selected={inProgressSelected}
        apiStatus={apiStatus}
        text="In Progress"
        data-tip="View In Progress status only"
        onClick={() => onFilterButtonClick(CONSTANTS.TAL_MODEL.FILTER.IN_PROGRESS)}
      />
      <StatusFilterButton
        color="vividRed"
        selected={errorSelected}
        apiStatus={apiStatus}
        text="Errored"
        data-tip="View Errored status only"
        onClick={() => onFilterButtonClick(CONSTANTS.TAL_MODEL.FILTER.ERRORED)}
      />
      <StatusFilterButton
        color="rioGrande"
        selected={completedSelected}
        apiStatus={apiStatus}
        text="Completed"
        data-tip="View Completed status only"
        onClick={() => onFilterButtonClick(CONSTANTS.TAL_MODEL.FILTER.COMPLETED)}
        m={{ l: '.625rem', r: '1.5rem' }}
      />
    </Div>
  );
}

StatusFilterButtonGroup.defaultProps = {
  apiStatus: '',
  onFilterButtonClick: noOp,
};

StatusFilterButtonGroup.propTypes = {
  selectedCode: PropTypes.string.isRequired,
  apiStatus: PropTypes.string,
  onFilterButtonClick: PropTypes.func,
};

export default React.memo(StatusFilterButtonGroup);
